"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketEncryptionInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=DeleteBucketEncryptionInput.js.map